module.exports = __webpack_public_path__ + "static/media/bbl.92b1e0d6.svg";